<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-6 searching">
                        <span class="h_page">Strategi Pembangunan</span> <br> <br>
                    </div>
                    <div class="col-md-3">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button @click="cek_misi_add" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data">
                                    <i class="material-icons">add</i>
                                </button>
                            </span>
                            <input @keyup="cari_data()" v-model="cari_value" type="text" class="form-control" placeholder="Cari data" id="caridata" >
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
                <br>
                <div class="row">
                    <div class="col-md-5">
                        <span class="huruf_input">Periode RPJMD</span>
                        <select @change="getMisi()" v-model="filter_rpjmd" class="form-control">
                            <option value="" >-- Semua Periode --</option>
                            <option v-for="data in list_rpjmd" :key="data.rpjmd_id" v-bind:value="data.rpjmd_id">	{{data.periode}}</option>
                        </select>
                    </div>

                    <div class="col-md-2"></div>


                    <div class="col-md-5">
                        <span class="huruf_input">Pilih Misi</span>
                        <select @change="getData()" v-model="filter_misi" class="form-control" :disabled="filter_rpjmd==''">
                            <option value="" >-- Semua Misi --</option>
                              <option v-for="(data) in list_misi" :key="data.misi_id" v-bind:value="data.misi_id">	&#91;	{{data.no_misi}}&#93;	{{data.uraian}}</option>
                        </select>
                    </div>

               </div>

        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-success kepala_table_f tabel_center">
                            <!-- <th class="tabel_center text-center" style="width: 5%">No.</th> -->
                            <th class="tabel_center text-center" style="width: 8%">Kode</th>
                            <th class="tabel_center text-center" style="width: 40%">Uraian Strategi</th>
                            <th class="tabel_center text-center" style="width: ">Keterangan</th>
                            <th class="tabel_center text-center" style="width: 15%">#</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-if="cek_load_data">
                                <td colspan="4" class="text-center">
                                    <img src="images/loading-plan.gif" width="450px">
                                </td>
                            </tr>
                            <template v-if="!cek_load_data">
                                <tr class="h_isitable" v-for="data in list_data" :key="data.sasaran_id">
                                    <!-- <td class="tabel_center text-center">1.</td> -->
                                    <td class="tabel_center text-center">{{data.no_misi}}.{{data.no_strategi}}</td>
                                    <td class="tabel_center" >{{data.uraian}}</td>
                                    <td class="tabel_center text-justify">{{data.keterangan}}</td>

                                    <td class="tabel_center text-center" >
                                        <button @click="get_strategi_dengan_sasaran(data)" class="btn bg-light-blue btn-xs waves-effect" title="Indikator Sasaran Pembangunan" id="edit_data" data-toggle="modal" data-target="#m_pilih_sasaran">
                                            <i class="material-icons" >control_point</i>
                                        </button>
                                            &nbsp;
                                        <button @click="selectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                            <i class="material-icons" >create</i>
                                        </button>
                                            &nbsp;
                                        <button @click="removeData(data.strategi_pembangunan_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                            <i class="material-icons" >clear</i>
                                        </button>
                                    </td>
                                </tr>
                            </template>

                        </tbody>
                    </table>
                </div>

                <hr>
                    <div class="text-center">
                        <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                            <i class="material-icons">skip_previous</i>
                        </button>
                        &nbsp;
                        <span style="font-size: 85%; color: #a5a5a5">
                            <b>{{page_first}} - {{page_last}}</b>
                        </span>
                        &nbsp;
                        <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                            <i class="material-icons">skip_next</i>
                        </button>
                    </div>
                <hr>
                <!-- ============================================================ MODAL ======================================================================== -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                </div>

                                    

                                    <form @submit.prevent="addData()">
                                        <div class="modal-body">

                                            

                                            <div v-if="!cek_misi" class="text-center">
                                                <span> 
                                                    <i class="material-icons col-orange">warning</i> <br>
                                                    <b>MOHON PILIH MISI TERLEBIH DAHULU...!!!</b>
                                                </span>
                                            </div>

                                            <div v-if="cek_misi">
    
                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">No Strategi</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="no_strategi" type="number" min="1" class="form-control" placeholder="Nomor Sasaran">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Uraian Sasaran</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="uraian" type="text" class="form-control" placeholder="Ex : Meningkatnya Pelayanan Publik">
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Keterangan</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <textarea v-model="keterangan" rows="4" class="form-control no-resize" placeholder="Masukan Keterangan..."></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="modal-footer">

                                            <button v-if="cek_misi" type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                            <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                        </div>
                                    </form>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                </div>
                            <form @submit.prevent="editData()">
                                <div class="modal-body">


                                    <div>
                                        <table style="width: 100%" class="h_isitablex">
                                            <tr>
                                                <td style="width: 10%">Periode</td>
                                                <td style="width: 1%">:</td>
                                                <td>{{rpjmd_periode}}</td>
                                            </tr>

                                            <tr>
                                                <td>Misi</td>
                                                <td>:</td>
                                                <td>[{{no_misi}}] {{misi_uraian}}</td>
                                            </tr>

                                        </table>
                                        <hr>
                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">No Strategi</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="no_strategi" type="number" min="1" class="form-control" placeholder="Nomor Strategi">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Uraian Sasaran</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <input v-model="uraian" type="text" class="form-control" placeholder="Ex : Meningkatnya Pelayanan Publik">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row clearfix">
                                            <div class="col-md-2 form-control-label">
                                                <label for="kode">Keterangan</label>
                                            </div>
                                            <div class="col-md-10">
                                                <div class="form-group">
                                                    <div class="form-line">
                                                        <textarea v-model="keterangan" rows="4" class="form-control no-resize" placeholder="Masukan Keterangan..."></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="modal-footer">
                                    <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                    <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL PILIH ISU STRATEGIS xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_pilih_sasaran" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">KETERKAITAN DENGAN SASARAN PEMBANGUNAN</h4>
                                </div>
                                <div class="modal-body">
                                    <button @click="btn_pilih_sasaran" data-toggle="modal" data-target="#m_list_sasaran" class="btn bg-light-blue btn-xs waves-effect">
                                        Tambah data
                                    </button>
                                    <hr>
                                    
                                    <div class="table-responsive">
                                        <table class="table table-bordered" style="width: 100%">
                                            <thead>
                                                <tr class="bg-info text-center kepala_table_f">
                                                    <th class="text-center" style="width: 10%">No</th>
                                                    <th class="text-center" style="width: 75%">Uraian Sasaran</th>
                                                    <th class="text-center" style="width: 15%"></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="h_isitable" v-for="(data) in list_strategi_dengan_sasaran" :key="data.relasi_id">
                                                    <td class="text-center">{{data.no_misi}}.{{data.no_tujuan}}.{{data.no_sasaran}}</td>
                                                    <td >{{data.sasaran_uraian}}</td>
                                                    <td class="text-center">
                                                        <button @click="remove_misi_dengan_sasaran(data)" class="btn bg-red btn-xs waves-effect" title="Hapus Data">
                                                            <i class="material-icons" >clear</i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>


                                </div>
                                <div class="modal-footer">

                                    <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL PILIH ISU STRATEGIS xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIST ISU STRATEGIS xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_list_sasaran" tabindex="-1" role="dialog" data-backdrop="static">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">PILIH LIST SASARAN</h4>
                                </div>
                                <div class="modal-body">
                                    <div class="table-responsive">
                                        <table class="table table-bordered" style="width: 100%">
                                            <thead>
                                                <tr class="bg-info text-center kepala_table_f">
                                                    <th class="text-center" style="width: 10%">No Isu</th>
                                                    <th class="text-center" style="width: 75%">Uraian Isu</th>
                                                    <th class="text-center" style="width: 15%">Pilih</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="h_isitable" v-for="(data) in list_sasaran" :key="data.sasaran_id">
                                                    <td class="text-center">{{data.no_misi}}.{{data.no_tujuan}}.{{data.no_sasaran}}</td>
                                                    <td >{{data.uraian}}</td>
                                                    <td class="text-center">
                                                        <input type="checkbox" :id="data.sasaran_id" :value="data.sasaran_id" v-model="pilih_sasaran" class="filled-in chk-col-light-blue">
                                                        <label :for="data.sasaran_id"></label>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="modal-footer">
                                    <button @click="add_strategi_dengan_sasaran" type="button" class="btn btn-info waves-effect" >SIMPAN</button>
                                    <button @click="emptyData()" type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </div>
                        </div>
                    </div>
                <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIST ISU STRATEGIS xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->



                <!-- ============================================================ MODAL ======================================================================== -->

        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>

    </div>
</template>


<script>

    const ADD_URL_MISI = URL_APP+'api/v1/planning_misi/';
    const ADD_URL_RPJMD = URL_APP+'api/v1/planning_rpjmd/';

    
    const ADD_URL_SASARAN = URL_APP+'api/v1/planning_sasaran_pembangunan/';
    const ADD_URL = URL_APP+'api/v1/planning_strategi/';


    export default {
        name: "planning_urusan",
        data() {
            return {

   
                filter_rpjmd: '',
                filter_misi: '',


                cek_misi : false,

                rpjmd_id : '',
                rpjmd_periode : '',

                misi_id : '',
                no_misi : '',
                misi_uraian : '',

                strategi_pembangunan_id : '',
                no_strategi : 0,
                uraian : '',
                keterangan : '',

                list_data: [],
                list_rpjmd: [],
                list_misi: [],
                list_strategi_dengan_sasaran : [],
                list_sasaran: [],
                data : [],

                pilih_sasaran : [],


                cek_sasaran : false,




                page_first : 1,
                page_last : 0,
                cari_value : '',
                cek_load_data : true,
            }
        },

        mounted() {
            this.getData();
            this.getPeriode();
            localStorage.sidemenu = 'planing';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            getPeriode: function(){
                fetch(ADD_URL_RPJMD, {
                    method : 'GET',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : "kikensbatara " + localStorage.token
                    },

                }).then(res => res.json()).then((res_data)=>{
                    //   console.log(res_data);
                    this.list_rpjmd = res_data
                })


            },

            getMisi: function(){
                if (this.filter_rpjmd == '') {
                    this.filter_misi = '';
                    this.filter_tujuan = '';
                }
                fetch(ADD_URL_MISI+'misi_id_rpjmd', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        rpjmd_id : this.filter_rpjmd
                    })

                }).then(res => res.json()).then((res_data)=>{
                        // console.log(res_data);
                        this.list_misi = res_data
                        this.getData();

                        
                })
            },

            getData: function(){
                this.cek_load_data = true;
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                    "content-type": "application/json",
                    authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        data_ke : this.page_first,
                        cari_value : this.cari_value,
                        rpjmd_id : this.filter_rpjmd,
                        misi_id : this.filter_misi,
                    })
                }).then((res) => res.json()).then((res_data) => {
                    // console.log(res_data);
                    this.list_data = res_data.data;
                    this.page_last = res_data.jml_data;
                    this.cek_load_data = false;
                })
            },


            addData: function(){
                fetch(ADD_URL+'createData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify({
                        rpjmd_id : this.filter_rpjmd,
                        misi_id : this.filter_misi,
                        no_strategi : this.no_strategi,
                        uraian : this.uraian,
                        keterangan : this.keterangan,

                    })
                }).then(res => res.json()).then((data_sasaran) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });
            },
            
            editData: function(){
                fetch(ADD_URL+'update', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({
                        tujuan_id : this.tujuan_id,
                        no_strategi : this.no_strategi,
                        uraian : this.uraian,
                        keterangan : this.keterangan,
                        sasaran_id : this.sasaran_id
                    })
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },


            selectData : function(data){
                this.rpjmd_id = data.rpjmd_id;
                this.rpjmd_periode = data.rpjmd_periode;

                this.misi_id = data.misi_id;
                this.no_misi = data.no_misi;
                this.misi_uraian = data.misi_uraian;

                this.strategi_pembangunan_id = data.strategi_pembangunan_id;
                this.no_strategi = data.no_strategi;
                this.uraian = data.uraian;
                this.keterangan = data.keterangan;
                this.data = data;

            },
            removeData : function(id){
                this.$swal({
                title: 'Apa Anda Ingin Menghapus Data?',
                text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Ya',
                cancelButtonText: 'Batal',
                showCloseButton: true,
                showLoaderOnConfirm: true
                }).then((result) => {
                if(result.value) {
                    fetch(ADD_URL+"delete", {
                        method : 'POST',
                        headers : {
                        'content-type' : 'application/json',
                        authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                            strategi_pembangunan_id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getData();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                }
                })
            },

            btn_pilih_sasaran : function(data){
                this.getSasaran(data);
            },

            getSasaran: function(data){
                fetch(ADD_URL_SASARAN+"sasaran_in_strategi", {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        misi_id : this.misi_id
                    })

                }).then((res)=> res.json()).then((res_data) => {

                    // console.log(res_data);
                    
                    var strategi_dengan_sasaran = this.list_strategi_dengan_sasaran

                    for (let j = 0; j < strategi_dengan_sasaran.length; j++) {
                        const element = strategi_dengan_sasaran[j].sasaran_id;
                        
                        for( var i = 0; i < res_data.length; i++){ 
                            if ( res_data[i].sasaran_id == element) {
                                res_data.splice(i, 1); 
                            }
                        }

                    }
                    this.list_sasaran = res_data;

                    // console.log(this.list_misi_dengan_sasaran);

                })
            },

            add_strategi_dengan_sasaran : function(){

                // console.log(this.pilih_sasaran);


                fetch(ADD_URL+'add_misi_dengan_sasaran', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : 'kikensbatara '+localStorage.token
                    },
                    body : JSON.stringify({
                        strategi_pembangunan_id : this.strategi_pembangunan_id,
                        sasaran_id : this.pilih_sasaran,
                    })
                }).then((data_misi) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.get_strategi_dengan_sasaran(this.data);
                    // this.view_misi_dengan_isu_strategis(this.misi_id);
                });

            },

            get_strategi_dengan_sasaran : function(data){

                this.selectData(data);

                // console.log(this.pilih_sasaran);
                fetch(ADD_URL+'readData_sasaran_in_strategi', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : 'kikensbatara '+localStorage.token
                    },
                    body : JSON.stringify({
                        strategi_pembangunan_id : data.strategi_pembangunan_id,
                    })
                }).then((res) => res.json()).then((res_data) => {
                    this.list_strategi_dengan_sasaran = res_data;
                    // console.log(res_data);
                });
            },

            remove_misi_dengan_sasaran: function(data){
                fetch(ADD_URL+'removeData_sasaran_in_strategi', {
                    method : 'POST',
                    headers : {
                        'content-type' : 'application/json',
                        authorization : 'kikensbatara '+ localStorage.token
                    },
                    body : JSON.stringify({
                        relasi_id : data.relasi_id
                    })
                }).then (res_data => {
                    this.get_strategi_dengan_sasaran(this.data);
                    this.alertku('success', 'Berhasil nenghapus Data!');
                })
                // console.log(this.data);
            },

            

            emptyData : function(){
                this.cek_misi = false;
                this.no_strategi = '';
                this.sasaran_id = '';
                this.uraian = '';
                this.keterangan = '';
                this.rpjmd_periode = '';
                this.no_misi = '';
                this.misi_uraian = '';

                this.tujuan_uraian = '';
                this.cek_sasaran = false;

                this.list_indikator = [];
                this.list_sasaran =[];
                this.pilih_sasaran =[];
            },

            cek_misi_add : function(){
                if (this.filter_misi == '') {
                    this.cek_misi = false;
                }else{
                    this.cek_misi = true;
                }
            },

            //PAGINASI
                alertku : function(type, title){
                this.$swal({
                    type: type,
                    title: title,
                    showConfirmButton: false,
                    timer: 800
                });
                },

                btn_prev : function(){
                    this.cek_load_data = true;
                    if(this.page_first>1){
                        this.page_first--
                    }else{
                        this.page_first = 1;
                    }
                    this.getData();
                },

                btn_next : function(){
                    this.cek_load_data = true;
                    if(this.page_first >= this.page_last){
                        this.page_first == this.page_last
                    }else{
                        this.page_first++;
                    }
                    this.getData();
                },

                cari_data : function(){
                    this.cek_load_data = true;
                    this.page_first = 1;
                    this.getData();
                }


            //PAGINASI
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
